export enum SCREENS {
  // text tools
  "STRING_TO_ASCII" = "/text-tools/string-to-ascii",
  "ASCII_TO_STRING" = "/text-tools/ascii-to-string",
  "TEXT_TO_UPPERCASE" = "/text-tools/text-to-uppercase",
  "TEXT_TO_LOWERCASE" = "/text-tools/text-to-lowercase",
  "WORD_COUNTER" = "/text-tools/word-counter",
  "REPLACE_SPACES" = "/text-tools/replace-spaces",
  "REMOVE_SPACES" = "/text-tools/remove-spaces",
  "REMOVE_EXTRA_SPACES" = "/text-tools/remove-extra-spaces",
  "GENERATE_RANDOM_STRING" = "/text-tools/random-string-generator",

  // calculator tools
  "SALARY_HIKE_PERCENTAGE_CALCULATOR" = "/calculator/salary-hike-percentage-calculator",

  // JSON tools
  "JSON_TO_STRING" = "/json-tools/json-to-string",
  "JSON_PARSER" = "/json-tools/json-formatter",
  "JSON_VALIDATOR" = "/json-tools/json-validator",
  "JSON_MINIFIER" = "/json-tools/secure-reliable-json-minifier-compressor",
  "JSON_DIFF" = "/json-tools/json-diff-compare",
  "JSON_TO_TYPESCRIPT" = "/json-tools/json-to-typescript-interface",
  "JSON_TO_XML" = "/json-tools/json-to-xml-converter",

  // XML tools
  "XML_FORMATTER" = "/xml-tools/xml-formatter",
  "XML_MINIFIER" = "/xml-tools/xml-minifier",
  "XML_TO_JSON" = "/xml-tools/xml-to-json-converter",

  // NUMBER tools
  "NUMBER_TO_WORDS" = "/number-tools/number-to-word-converter",

  // encoding/decoding tools
  "URL_DECODE" = "/encoding-decoding-tools/url-decoder",
  "URL_ENCODE" = "/encoding-decoding-tools/url-encoder",

  // Others
  "UUID_GENERATOR" = "/tools/uuid-generator",

  // Security tools
  "GENERATE_RANDOM_PWD"= "/security-tools/random-password-generator",

  // Other screens
  "HOME" = "/",
  "JSON_EXAMPLES" = "/sample-data/json-examples",
  "PRIVACY_POLICY" = "fireboxtools-privacy-policy",
  "SAVE_FEEDBACK" = "/save-feedback",
}
